"use client";

import { useAviFilterTags } from "../hooks/useAviFilterTags";
import { FilterTags } from "./filterTags";

export function AviFilterTags() {
  const { tags, reset } = useAviFilterTags();
  return <FilterTags tags={tags} onReset={reset} />;
}
